var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftarrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.452,
    height: 18,
    viewBox: "0 0 19.452 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_309",
    x: 0,
    y: 1.5,
    width: 19.452,
    height: 15.069,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5516",
    "data-name": "Group 5516",
    transform: "translate(-1005.5 -1727)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4376",
    "data-name": "Rectangle 4376",
    width: 18,
    height: 18,
    transform: "translate(1006 1727)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_500",
    "data-name": "Group 500",
    transform: "translate(959 1589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    "data-name": "Group 346",
    transform: "translate(0 -12.537)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 46.5, 150.54)",
    filter: "url(#Path_309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309-2",
    "data-name": "Path 309",
    d: "M15.61,5.192H2.875L6.629,1.437A.842.842,0,1,0,5.439.247L.247,5.439a.842.842,0,0,0,0,1.191l5.192,5.192a.842.842,0,1,0,1.191-1.191L2.875,6.876H15.61a.842.842,0,1,0,0-1.684Z",
    transform: "translate(1.5 3)",
    fill: "#5a5757"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftarrow);
export default __webpack_public_path__ + "static/media/Leftarrow.9d1564b65f10c70951884e615b2384c3.svg";
export { ForwardRef as ReactComponent };